// extracted by mini-css-extract-plugin
module.exports = {"modal":"ErrorModal_modal__P0HJk","icon":"ErrorModal_icon__1wZ5f","body":"ErrorModal_body__2TKfk","button":"ErrorModal_button__1kVy1"};